var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJvaLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 43.619,
    viewBox: "0 0 150 43.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #59c4c6;\n      }\n\n      .cls-2 {\n        fill: #003462;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196",
    transform: "translate(-118.104 -199.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196-2",
    "data-name": "Grupo 196",
    transform: "translate(202.58 204.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_521",
    "data-name": "Trazado 521",
    className: "cls-1",
    d: "M490.155,280.405H468.582l.568,3.882h21Z",
    transform: "translate(-466.26 -265.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_522",
    "data-name": "Trazado 522",
    className: "cls-1",
    d: "M486.744,249.448h-22.7l.568,3.882h22.127Z",
    transform: "translate(-462.85 -241.781)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_523",
    "data-name": "Trazado 523",
    className: "cls-1",
    d: "M493.565,311.363h-20.45l.568,3.882h19.882Z",
    transform: "translate(-469.671 -288.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_524",
    "data-name": "Trazado 524",
    className: "cls-1",
    d: "M490.589,218.49H459.208a5.649,5.649,0,0,1,.231,1.055l.414,2.828h24.216Z",
    transform: "translate(-459.208 -218.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_525",
    "data-name": "Trazado 525",
    className: "cls-1",
    d: "M477.648,342.321l.569,3.882h26.035l-6.724-3.882Z",
    transform: "translate(-473.081 -311.653)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    transform: "translate(118.104 204.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_526",
    "data-name": "Trazado 526",
    className: "cls-2",
    d: "M324.828,253.225l3.074-5.343h11.865l.865,5.343H351L346.145,220.1a1.929,1.929,0,0,0-.445-1.038,1.616,1.616,0,0,0-1.335-.494H333.506l-19.683,34.66Zm13.16-24.821,1.286,11.123h-7.367Z",
    transform: "translate(-265.352 -218.565)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_527",
    "data-name": "Trazado 527",
    className: "cls-2",
    d: "M171.671,218.564l-4.132,7.409-8.193,14.69-.278-20.615a1.564,1.564,0,0,0-.046-.3,1.85,1.85,0,0,0-.16-.428l-.006-.013-.008-.013a2.517,2.517,0,0,0-.142-.234.973.973,0,0,0-.128-.134,1.518,1.518,0,0,0-1.1-.36h-15.2l-4.275,21.555a7.6,7.6,0,0,1-1.879,3.905,4.517,4.517,0,0,1-3.263,1.236,3.5,3.5,0,0,1-2.447-.717,2.731,2.731,0,0,1-.72-1.21c-.041-.132-.075-.273-.105-.419-.007-.034-.014-.069-.021-.1-.027-.148-.051-.3-.067-.461v-.007a1.031,1.031,0,0,0-.115-.4H118.1s.012,1.439.012,1.77a7.358,7.358,0,0,0,.721,3.273,9.524,9.524,0,0,0,3.189,3.659A16.086,16.086,0,0,0,126.8,252.9a18.692,18.692,0,0,0,5.216.766,23.887,23.887,0,0,0,6.145-.727h0c.364-.1.719-.2,1.063-.319l.067-.022c.353-.121.7-.249,1.03-.391h0c.258-.11.51-.229.757-.352.1-.048.189-.1.283-.149.145-.077.289-.154.43-.236.119-.068.235-.139.351-.211s.207-.13.309-.2c.135-.089.269-.178.4-.272.059-.042.117-.086.175-.129a12.76,12.76,0,0,0,2.022-1.854v0c.28-.318.552-.647.805-1a19.252,19.252,0,0,0,3.065-7.341l.448-2.1.487,13.271a1.738,1.738,0,0,0,.409,1.038,1.6,1.6,0,0,0,1.331.494h11.986l9.815-17.138V236l10-17.44Z",
    transform: "translate(-118.104 -218.564)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198",
    transform: "translate(230.336 199.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_528",
    "data-name": "Trazado 528",
    className: "cls-2",
    d: "M590.169,199.937l-18.888,11.247v21.467l18.888,10.9,18.881-10.879,0-21.493Z",
    transform: "translate(-571.282 -199.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_529",
    "data-name": "Trazado 529",
    className: "cls-3",
    d: "M602.2,235.969l-15.029-8.677,15.061-8.69,14.978,8.69Z",
    transform: "translate(-583.238 -213.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_530",
    "data-name": "Trazado 530",
    className: "cls-1",
    d: "M662.669,271.018,647.652,279.7l-.016-17.294,15.017-8.647Z",
    transform: "translate(-628.727 -240.427)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJvaLogoColor);
export default __webpack_public_path__ + "static/media/jvaLogoColor.2f00eb8eff5d440457b91fa6769541a3.svg";
export { ForwardRef as ReactComponent };